module.exports = __webpack_public_path__ + "img/logo.dec73ff3.svg";